export const resolveApiOrigin = (
  configuredApiUrl?: string | null,
  windowOrigin?: string | null
) => {
  if (configuredApiUrl) {
    try {
      return new URL(configuredApiUrl).origin;
    } catch {
      return null;
    }
  }

  if (windowOrigin) {
    return windowOrigin;
  }

  return null;
};

export const resolveAvatarUrlWithOrigin = (
  value: string | null | undefined,
  apiOrigin: string | null
) => {
  if (!value) {
    return null;
  }

  if (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('data:')) {
    return value;
  }

  if (value.startsWith('/')) {
    return apiOrigin ? `${apiOrigin}${value}` : value;
  }

  return value;
};
